export const ALLOWED_EMAILS = [
  'loricorpuz@gmail.com',
  'mossda@gmail.com', // Dave
]

export const USER_CONFIG = {
  Lori: {
    label: "Lori",
    icon: '\u{1F469}',
    focus: 'Systems analysis, agent-based modeling, institutional mechanics',
  },
  Dave: {
    label: "Dave",
    icon: '\u{1F468}',
    focus: 'LEAP options on private credit, Blue Owl thesis, PE-CLO ecosystem',
  },
}

export const DEFAULT_USER = 'Lori'

export const TABS = {
  MARKET: 'market',
  INSTITUTIONS: 'institutions',
  MECHANICS: 'mechanics',
  RISK_LAB: 'risk_lab',
  RESEARCH: 'research',
}

// Major private credit institutions to track
export const INSTITUTIONS = {
  OWL: { ticker: 'OWL', name: 'Blue Owl Capital', type: 'BDC / Direct Lending', focus: 'Permanent capital, direct lending + GP stakes' },
  ARES: { ticker: 'ARES', name: 'Ares Management', type: 'Direct Lending / CLO', focus: 'Largest private credit manager' },
  APO: { ticker: 'APO', name: 'Apollo Global', type: 'Private Credit / Insurance', focus: 'Insurance-linked private credit' },
  BX: { ticker: 'BX', name: 'Blackstone', type: 'Direct Lending / BDC', focus: 'BCRED flagship fund' },
  KKR: { ticker: 'KKR', name: 'KKR & Co', type: 'Private Credit / CLO', focus: 'PE + credit integration' },
  MAIN: { ticker: 'MAIN', name: 'Main Street Capital', type: 'BDC', focus: 'Lower middle market' },
  FSK: { ticker: 'FSK', name: 'FS KKR Capital', type: 'BDC', focus: 'KKR-managed BDC' },
  ARCC: { ticker: 'ARCC', name: 'Ares Capital Corp', type: 'BDC', focus: 'Largest publicly traded BDC' },
  PSEC: { ticker: 'PSEC', name: 'Prospect Capital', type: 'BDC', focus: 'Diversified credit' },
  GBDC: { ticker: 'GBDC', name: 'Golub Capital BDC', type: 'BDC', focus: 'Middle market lending' },
  TPVG: { ticker: 'TPVG', name: 'TriplePoint Venture', type: 'BDC / Venture Lending', focus: 'Tech venture debt' },
  HTGC: { ticker: 'HTGC', name: 'Hercules Capital', type: 'BDC / Venture Lending', focus: 'Technology lending' },
  OCSL: { ticker: 'OCSL', name: 'Oaktree Specialty', type: 'BDC', focus: 'Howard Marks / Oaktree' },
  BXSL: { ticker: 'BXSL', name: 'Blackstone Secured', type: 'BDC', focus: 'Senior secured lending' },
}

// CLO market structure data
export const CLO_TRANCHES = [
  { tranche: 'AAA', typical_spread: '140-160bp', subordination: '35-38%', rating: 'Aaa/AAA' },
  { tranche: 'AA', typical_spread: '180-220bp', subordination: '25-28%', rating: 'Aa2/AA' },
  { tranche: 'A', typical_spread: '240-280bp', subordination: '19-22%', rating: 'A2/A' },
  { tranche: 'BBB', typical_spread: '350-400bp', subordination: '13-15%', rating: 'Baa2/BBB' },
  { tranche: 'BB', typical_spread: '600-700bp', subordination: '8-10%', rating: 'Ba2/BB' },
  { tranche: 'Equity', typical_spread: 'Residual', subordination: '0%', rating: 'NR' },
]

// Leverage stack from Dave's screenshots
export const LEVERAGE_STACK = [
  { layer: 1, entity: 'Company', leverage: '5x', cumulative: '5x', description: '$1 EBITDA supports $5 of debt' },
  { layer: 2, entity: 'CLO', leverage: '10x', cumulative: '50x', description: '$50M equity in CLO controls $500M of loans' },
  { layer: 3, entity: 'AAA Repo', leverage: '10x', cumulative: '500x', description: '$30M bank equity controls $300M AAA position' },
]

// Key metrics for private credit fund analysis (from MSCI research)
export const FUND_METRICS = {
  riskDecomposition: ['Public factors', 'Private credit factors', 'PE exposure factors'],
  fundLifecycle: ['Senior debt %', 'Spread duration', 'Concentration risk'],
  portfolioFit: ['Beta to total portfolio', 'Correlation', 'Marginal risk contribution'],
  transparency: ['Security-level holdings', 'Look-through analytics', 'Style drift detection'],
}

// Private credit market sizing
export const MARKET_DATA = {
  totalAUM: '$1.7T',
  projectedAUM2028: '$2.8T',
  cloMarketSize: '$1.1T',
  leveragedLoanMarket: '$1.4T',
  cloShareOfLeveragedLoans: '70%',
  peShareOfNewLoanSupply: '60%',
  bdcMarketCap: '$120B+',
}

// Sector classifications for private credit
export const CREDIT_SECTORS = [
  'Direct Lending',
  'BDC (Business Development Company)',
  'CLO Manager',
  'Mezzanine / Junior Capital',
  'Distressed / Special Situations',
  'Venture Lending',
  'Real Estate Credit',
  'Infrastructure Credit',
  'Asset-Based Lending',
  'Specialty Finance',
]
